export default __webpack_public_path__ + "static/media/bowie65.caf7bbfd.webp";